import React from "react";

const MapSection = () => {
  return (
    <div
      className="map-wrapper"
      style={{ width: "100%", height: "550px", lineHeight: 0 }}
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3669.810946302933!2d72.59400937600961!3d23.10401551328272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e83c939ce4a81%3A0x1cc3027aff605078!2sThe%20Spice%20Root%20Caterers%20And%20Events%20Organizer!5e0!3m2!1sen!2sin!4v1768638020384!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
    </div>
  );
};

export default MapSection;
